const phoneMask = (phone) => {
	if (!phone || phone.length !== 10) return phone;
	return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
};

export default phoneMask;
